import isUnknownObject from './isUnknownObject';
import NodeTypes from './NodeTypes';
/**
 * Returns whether provided node is an HTML document.
 */

export default function isDocument(node) {
  return isUnknownObject(node) && node.nodeType === NodeTypes.DOCUMENT_NODE;
}
//# sourceMappingURL=isDocument.js.map